export enum IMappingContext {
    MASTER = "master",
    CATALOG = "catalog",
}

export interface IIndexedPosition {
    text: string,
    positionPath: number[]
    level: number
}